import { Component, Inject, ViewEncapsulation } from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material';

@Component({
   selector: 'app-user-message',
   templateUrl: 'app-user-message.component.html',
   styleUrls: ['app-user-message.component.scss']
})
export class AppUserMessageComponent {

   public _message = 'Heute sonnig, 25°';    // Party! 🍕

   constructor(
      @Inject(MAT_SNACK_BAR_DATA) private data: any
   ) {
      this._message = data.message;
   }

   public isWarning(): boolean {
      return this.data.type === 'WARNING';
   }

   public isError(): boolean {
      return this.data.type === 'ERROR';
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/library/app-user-message/app-user-message.component.ts